// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BHxM","content":"styles_content__2GC1r","tableWrap":"styles_tableWrap__1UAC-"};